import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from './api/base-api';
import { authReducer } from './slices/auth.slice';
import { themeReducer } from './slices/theme.slice';
import { uiReducer } from './slices/ui.slice';
import { settingsReducer } from './slices/settings.slice';
import { env } from '@/config';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
    ui: uiReducer,
    settings: settingsReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
  devTools: !env.isProduction,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
